import { color } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Box from "../../Box/Box";
import { thumbHeight, thumbSize } from "./ThumbStyle";
export const IndicatorMark = styled(Box) `
  width: ${thumbHeight}px;
  height: ${thumbSize}px;
  border: 1px solid ${color.status.info.default};
  border-radius: 2px;
  background-color: ${color.status.info.default};
  pointer-events: none;

  &.disabled {
    border-color: ${color.background.darker};
    background-color: ${color.background.darker};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5kaWNhdG9yTWFyay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NsaWRlci9zdHlsZWQvSW5kaWNhdG9yTWFyay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDdkUsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxHQUFHLE1BQU0sZUFBZSxDQUFDO0FBQ2hDLE9BQU8sRUFBRSxXQUFXLEVBQUUsU0FBUyxFQUFFLE1BQU0sY0FBYyxDQUFDO0FBRXRELE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7V0FDN0IsV0FBVztZQUNWLFNBQVM7c0JBQ0MsS0FBSyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTzs7c0JBRXpCLEtBQUssQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU87Ozs7b0JBSTNCLEtBQUssQ0FBQyxVQUFVLENBQUMsTUFBTTt3QkFDbkIsS0FBSyxDQUFDLFVBQVUsQ0FBQyxNQUFNOztDQUU5QyxDQUFDIn0=